import classNames from 'classnames'
import { PropsWithChildren } from 'react'

import { SpacingType } from '@ui/design-system/spacing'

import { useWindowResize } from '@utils/domUtils'

import styles from './Grid.module.scss'

interface GridProps {
  className?: string
  mobileSameSize?: boolean
  maxCardWidth?: number
  fixedHeight?: boolean
  gap?: SpacingType
  mobileGridTemplateColumns?: string
}

export const Grid: React.FC<PropsWithChildren<GridProps>> = (props) => {
  const {
    children,
    maxCardWidth = 290,
    className,
    mobileSameSize,
    fixedHeight,
    gap,
    mobileGridTemplateColumns,
  } = props
  const isMobile = useWindowResize()

  const gridTemplateColumns = isMobile
    ? mobileGridTemplateColumns ?? `repeat(auto-fill, minmax(${maxCardWidth * 0.6}px, 1fr))`
    : `repeat(auto-fill, minmax(${maxCardWidth}px, 1fr))`

  const resolvedGap: SpacingType = gap ?? (isMobile ? 'x8' : 'x16')

  return (
    <div
      style={{ gridTemplateColumns }}
      className={classNames(styles.grid, className, styles[`gap-${resolvedGap}`], {
        [styles.mobileResize]: !mobileSameSize,
        [styles.autoRows]: fixedHeight,
      })}
    >
      {children}
    </div>
  )
}
